/**
 * 组图编辑图片item
 * */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import MyIconSvg from '../../../../iconSvg/svg'
import {Form, Input, Modal} from "antd";
import Titlepicfile from "../../../../../components/titlepicfile/Titlepicfile";

const FormItem = Form.Item;
const { TextArea } = Input;

class MosaicReleaseImage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            description: '',//描述图片的值
            file: props.file,
            focus: false,
            editPhotoVisible: false,
        }
    }


    componentDidMount() {
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.file.uid !== this.state.file.uid) {
            this.setState({file:nextProps.file})
        }
    }


    render() {
        let keyNum = this.props.keyNum;
        let paddingRight = (keyNum+1)%5 == 0 ? 0 : 30;
        return (
            <div style={{paddingRight: paddingRight, paddingBottom: 13}}>
                {this.renderImage()}
                {this.renderUpdate()}
            </div>
        );
    }

    renderImage = () => {
        let {file} = this.state;
        const {disable} = this.props;
        let range = file.describe && file.describe.length || 0;
        // console.log('file',file)
        return (
            <div style={{display: 'flex'}}>
                <div className={"imageInput"}  style={{position: 'relative', width: 200, height: 112.5}}>
                    <Titlepicfile src={file.url} style={{width: 200, height: 112.5}}/>
                    <div onClick={() => {
                        if(disable) return false;
                        this.inputRef.focus();
                        this.inputRef.selectionStart = range;
                        this.inputRef.selectionEnd = range;
                        if (typeof this.props.onFocusCall == 'function') {
                            this.props.onFocusCall(this.state.file, "");
                            this.props.onFocusCall(this.state.file, this.state.file.uid)
                        }
                        this.setState({}, () => {
                        })
                    }}>
                        <Input disabled={disable} ref={inputRef => this.inputRef = inputRef}
                               value={file.describe}
                               placeholder={(!this.props.focusKey.includes(this.state.file.uid))?'请输入描述信息':null}
                               readOnly={!this.props.focusKey.includes(this.state.file.uid)}
                               onChange={e => {
                                   if(disable) return false;
                                   this.state.file.describe = e.target.value;
                                   console.log(this.state.file.describe , e.target.value);
                                   this.setState({})
                               }}
                               autoFocus={this.props.focusKey.includes(this.state.file.uid)}
                               onBlur={()=>{
                                   if(disable) return false;
                                   if (typeof this.props.onEditDescriptionCall == 'function') {
                                       this.props.onEditDescriptionCall(this.state.file,this.state.file.uid)
                                   }
                                   if (typeof this.props.onFocusCall == 'function') {
                                       this.props.onFocusCall(this.state.file,"")
                                   }
                               }}
                               style={{
                                   position: 'absolute', bottom: 0, left: 0,width: 200, height: 20,
                                   paddingLeft: 8,lineHeight:'20px',
                                   color: 'white', background: 'rgb(0,0,0,0.4)',
                                   borderRadius: '0px', border: 'none',zIndex:99,
                                   paddingRight:24
                               }}/>
                        <div style={{position: 'absolute',zIndex:100,cursor:'pointer', bottom: 3, right: -5,width:40,height:40,display:'flex',alignItems:'flex-end',justifyContent:'center'}}>
                            <MyIconSvg type={'edit'} style={{size: 14,}}  colors={'#ffffff'}/>
                        </div>
                    </div>
                    <style>
                        {
                            `
                         .imageInput .ant-input{color:white}
                        `
                        }
                    </style>
                </div>

            </div>
        )
    };

    renderUpdate = () => {
        const {disable, hideSetTitlePic} = this.props;
        return (
            <div style={{display: 'flex', fontSize: 12}}>
                {disable ? null :
                    <>
                        <div style={{cursor: 'pointer'}} onClick={() => {
                            this.setState({editPhotoVisible: true})
                        }}>修改
                        </div>
                        <div onClick={() => {

                            this.editCover(this.state.file.url,this.state.file.title+"-裁剪.png",(path) => {
                                this.state.file.url = path;
                                this.setState({});
                            })
                        }} style={{marginLeft: 16, cursor: 'pointer'}}>编辑
                        </div>
                        <div onClick={() => {
                            if (typeof this.props.onDeleteCall == 'function') {
                                this.props.onDeleteCall(this.state.file.uid)
                            }
                        }} style={{color: 'red', marginLeft: 16, cursor: 'pointer'}}>删除
                        </div>
                        {!hideSetTitlePic && <div onClick={() => {
                            if (typeof this.props.onEditTitlePicCall == 'function') {
                                this.props.onEditTitlePicCall(this.state.file.url)
                            }
                        }} style={{marginLeft: 36, cursor: 'pointer'}}>设为预览图
                        </div>}
                    </>
                }
                {this.renderEditPhoto()}
            </div>

        )
    }

    editCover = (src, name, call) => {
        if (src) {
            window.edit.callback = function (obj) {
                call && call(obj.path)
            };
            window.edit.openEditPictureFrame(src, name);
        } else {
            console.log("待编辑图片地址丢失")
        }
    };



    renderEditPhoto = () => {
        let {file} = this.state;
        let name = file&&file.title?file.title.substring(0, file.title.lastIndexOf(".")):'';
        let suffix = file&&file.title?file.title.substring(file.title.lastIndexOf(".")+1):'';
        return (
            <Modal
                centered={true}
                title="组图信息编辑"
                visible={this.state.editPhotoVisible}
                onOk={()=>{
                    if (typeof this.props.onEditDescriptionCall == 'function') {
                        this.props.onEditDescriptionCall(this.state.file,this.state.file.uid)
                    }
                    this.setState({editPhotoVisible: false})
                }}
                maskClosable={false}
                onCancel={() => {
                    this.setState({editPhotoVisible: false})
                }}
                width={500}
                destroyOnClose={true}
            >
                <Form labelCol={{span: 4}} wrapperCol={{span: 17}}
                      onSubmit={(e)=>{ // 启动了表单的回车确认功能
                      }}>
                    <FormItem
                        label={'图标标题'}
                        required={true}
                    >
                        <div>
                            <Input
                                style={{ width: 275 }}
                                onChange={(e)=>{
                                    this.state.file.title = e.target.value + '.'+ suffix;
                                    this.setState({},()=>{

                                    })
                                }}
                                value={name}
                            />
                            <span> . {suffix}</span>
                        </div>

                    </FormItem>
                    <FormItem
                        label={'图片描述'}
                        required={false}
                    >
                        <TextArea
                            style={{ resize: 'none',background: '#eef2fb'}}
                            value={file.describe}
                            onChange={(e)=>{
                                this.state.file.describe = e.target.value;
                                this.setState({})
                            }}
                            placeholder="请输入"
                            autoSize={{ minRows: 3, maxRows: 5 }}
                        />
                    </FormItem>
                </Form>
            </Modal>
        )
    };


}

MosaicReleaseImage.propTypes = {};

export default MosaicReleaseImage;
